import { render } from "./Catalog.vue?vue&type=template&id=02373a06&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=02373a06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02373a06"]])

export default __exports__